import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import router from "./routes";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "./layout/custom.css";
import App from "./App";
import AuthProvider from "./context/AuthContext";
import { LoadingProvider } from "./context/LoadingContext";
import LoadingOverlay from "./components/common/LoadingOverlay";
import { AlertProvider } from "./context/AlertContext";
import AlertOverlay from "./components/common/AlertOverlay";
import { ModalProvider } from "./context/ModalContext";
import GlobalModalOverlay from "./components/common/GlobalModalOverlay";
import "./index.css"

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <LoadingProvider>
    <AlertProvider>
      <ModalProvider>
        <LoadingOverlay />
        <AlertOverlay />
        <GlobalModalOverlay />
        <React.StrictMode>
          <AuthProvider>
            <RouterProvider router={router} />
          </AuthProvider>
        </React.StrictMode>
      </ModalProvider>
    </AlertProvider>
  </LoadingProvider>
);
